import api from './api';

export const taskService = {
  getAll: (params = {}) => api.get('/tasks/', { params }),
  create: (data) => api.post('/tasks/', data),
  getById: (id) => api.get(`/tasks/${id}`),
  update: (id, data) => api.put(`/tasks/${id}`, data),
  toggleComplete: (id, complete) => api.patch(`/tasks/${id}/complete?complete=${complete}`),
  delete: (id) => api.delete(`/tasks/${id}`),
};
